var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing_three"},[_c('TheHeader',{attrs:{"appActiveLang":_vm.activeLang}}),_c('router-view'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }